// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fVx_S{margin-bottom:32px}.WIx8Z{flex:none;width:20px;height:20px;margin-top:6px}[data-device=mobile] .WIx8Z{margin-top:2px}.wW_yi{max-width:100%}.d2z_j{display:grid;grid-template-columns:minmax(0, 11fr) minmax(0, 9fr);gap:24px;align-items:start}.UO76q{margin-top:auto}.r6BvQ{height:334px;margin-bottom:-16px;box-sizing:border-box;min-height:0;overflow-y:auto;overscroll-behavior:contain}.YhbdR{width:100%;text-align:left;border:0;cursor:pointer}.YhbdR:hover{background:#f4f4f7}.VFx_V{flex:none;width:28px;height:28px;border-radius:8px;background:#f4f4f7;color:#535382}.g1i5L .VFx_V{background:#fff}.NStdO{white-space:nowrap;font-variant-numeric:tabular-nums}.Bg43F{border:1px dashed #d4d4e0;border-radius:12px;text-align:center}.is0n2{display:inline-block;white-space:nowrap}.D_bMC{display:grid;grid-template-columns:repeat(auto-fit, minmax(260px, 1fr));gap:24px 32px;align-items:center;border-radius:12px;background:#f4f4f7}[data-device=mobile] .D_bMC{gap:12px 16px}.J7MLq{flex:none;box-sizing:border-box;width:14px;height:14px;margin:3px;border:1.5px solid #6942f8;border-radius:50%;animation:GV_7w 1.4s ease-out infinite}.J7MLq::after{content:"";width:4px;height:4px;border-radius:50%;background:#6942f8}@keyframes GV_7w{0%{box-shadow:0 0 0 0 rgba(105,66,248,.35)}100%{box-shadow:0 0 0 7px rgba(105,66,248,0)}}@media(prefers-reduced-motion: reduce){.J7MLq{animation:none}}.VagQq{grid-template-columns:minmax(0, 1fr)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"mobileMaxWidth": `560px`,
	"tabletMinWidth": `561px`,
	"tabletMaxWidth": `1024px`,
	"desktopMinWidth": `1025px`,
	"smallScreenMaxWidth": `1400px`,
	"largeScreenMinWidth": `1401px`,
	"section": `fVx_S`,
	"sparkle": `WIx8Z`,
	"skeletonLine": `wW_yi`,
	"deckAndList": `d2z_j`,
	"loadingActions": `UO76q`,
	"sideList": `r6BvQ`,
	"sideListRow": `YhbdR`,
	"sideListIcon": `VFx_V`,
	"current": `g1i5L`,
	"rowAmount": `NStdO`,
	"doneBox": `Bg43F`,
	"hideForNow": `is0n2`,
	"buildingUp": `D_bMC`,
	"learningRing": `J7MLq`,
	"learning-pulse": `GV_7w`,
	"deckOnly": `VagQq`
};
export default ___CSS_LOADER_EXPORT___;
